import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderExchangeManagementListWrap from '../../views/order/exchange/management/list/OrderExchangeManagementListWrap';
import { orderActions } from '../../store/modules/order';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
  ORDER_EXCHANGE_MANAGEMENT_MODEL,
} from '../../store/modules/order/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import { INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE } from '../../constants/service/invalidMsg/orderInvalidMsg';
import {
  EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST,
  ORDER_EXCHANGE_STATUS,
} from '../../constants/service/app/orderConstants';
import { asyncSimpleModal, checkIsNonSelectedList } from '../../lib/common';
import moment, { addBusinessDays } from '../../lib/moment';

class OrderExchangeManagementContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderExchangeManagement'],
      value: ORDER_EXCHANGE_MANAGEMENT_MODEL,
    });
  };

  getList = (data) => {
    const { orderExchangeManagement, getOrderExchangeManagementList } = this.props;
    const { orderExchangeManagementList } = orderExchangeManagement;

    getOrderExchangeManagementList({
      ...orderExchangeManagementList,
      ...data,
    });
  };

  /**
   *  전체 엑셀 다운로드
   */
  getAllListExcelDownload = () => {
    const { orderExchangeManagement, getOrderExchangeManagementAllListExcelDownload, adminInfo } = this.props;
    const { searchOption, filterOption } = orderExchangeManagement.orderExchangeManagementList;

    getOrderExchangeManagementAllListExcelDownload({
      email: adminInfo.email,
      fileName: '교환관리 전체 리스트',
      searchOption,
      filterOption,
    });
  };

  /**
   *  선택 엑셀 다운로드
   */
  getSelectedListExcelDownload = () => {
    const { orderExchangeManagement, getOrderExchangeManagementSelectedListExcelDownload } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;
    const { searchOption, filterOption } = orderExchangeManagementList;

    if (!orderExchangeManagementSelectedList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderExchangeManagementSelectedListExcelDownload({
      fileName: '교환관리 선택 리스트',
      searchOption,
      filterOption,
      selectedOrderItemList: orderExchangeManagementSelectedList,
    });
  };

  /**
   * 상품 주문 취소 선택 callback
   */
  onCheckOrderItem = (list) => {
    const { setData } = this.props;

    setData({
      path: ['orderExchangeManagement', 'orderExchangeManagementSelectedList'],
      value: list,
    });
  };

  /**
   *  교환 수거 완료
   *  [교환 요청(0)]
   */
  completeCollectionOrderExchange = async () => {
    const { orderExchangeManagement, completeCollectionOrderExchange } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  상품 주문 교환 상태가 교환 요청(0)인 경우에만
     *  교환 수거 완료처리를 할 수 있음
     */
    const targetOrderExchangeItemList = orderExchangeManagementList.list.filter(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        item.orderItemExchangeStatus === ORDER_EXCHANGE_STATUS.REQUEST,
    );

    /**
     *  선택한 상품 주문서에 교환 요청(0)건이 없을 경우
     */
    if (!targetOrderExchangeItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 완료처리',
        message: '선택한 주문은 수거 완료처리를 할 수 없습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 결제 교환 요청(0)건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const completeCollectionConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '수거 완료처리',
      message:
        `선택하신 (${orderExchangeManagementSelectedList.length}개) 상품 주문건 증 수거 완료처리가\n` +
        `가능한 상품 주문은 (${targetOrderExchangeItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '수거 완료처리',
    });

    /**
     *  선택된 반품 요청(0) 상품 리스트를
     *  서버로 전송해서 반품 수거 완료처리로 업데이트함
     */
    if (completeCollectionConfirmResult) {
      completeCollectionOrderExchange({
        orderItemIdList: targetOrderExchangeItemList.map((item) => item.orderItemId),
      });
    }
  };

  /**
   *  수거 실패 -> 교환 거부 처리하기
   *  [교환 요청(0)]
   */
  failCollectionRejectOrderExchange = async () => {
    const { orderExchangeManagement, toggleModal } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  수거 실패 -> 교환 거부는 1 건씩만 가능합니다.
     */
    if (orderExchangeManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 교환 거부 처리',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 교환 상태가 교환 요청(0)인 경우에만
     *  수거 실패 -> 교환 거부 처리를 할 수 있음
     */
    const targetOrderExchangeItem = orderExchangeManagementList.list.find(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        item.orderItemExchangeStatus === ORDER_EXCHANGE_STATUS.REQUEST,
    );

    /**
     *  선택한 상품 주문서에 교환 요청(0)건이 없을 경우
     */
    if (!targetOrderExchangeItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 교환 거부 처리',
        message: '교환 요청된 상품 주문건에 대해서만 수거 실패 -> 교환 거부 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  교환 요청일 +7 이후 건에만 수거 실패 -> 반품 거부 처리가 가능하다.
     */
    if (moment.duration(moment().diff(addBusinessDays(targetOrderExchangeItem.exchangeRequestDate, 7))).asDays() < 0) {
      await asyncSimpleModal({
        type: 'error',
        title: '수거 실패 -> 교환 거부 처리',
        message: '교환 요청일 +7일 (영업일 기준) 이후 건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  판매자에게 확인 모달을 띄운다.
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const failCollectionRejectExchangeConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '한번 더 확인해주세요',
      message:
        '1. 구매자에게 발송 여부를 확인해주세요\n' + '2. 구매자에게 사유를 먼저 안내하고, 거부 처리를 진행해주세요.',
    });

    /**
     *  수거 실패 -> 교환 거부 처리를 위해 교환 거부 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    if (failCollectionRejectExchangeConfirmResult) {
      toggleModal({
        name: 'rejectExchangeModal',
        data: {
          orderItemId: targetOrderExchangeItem.orderItemId,
          productName: targetOrderExchangeItem.productName,
          productPrice: targetOrderExchangeItem.productPrice,
          /**
           *  수거 실패 -> 교환 거부, 그냥 교환 거부는 알림톡 내용이 다르다
           *  exchangeStatus 값으로 위의 두가지를 판단이 가능하므로
           *  exchangeStatus 값을 넘긴다.
           */
          orderItemExchangeStatus: targetOrderExchangeItem.orderItemExchangeStatus,
        },
      });
    }
  };

  /**
   * 교환 사유 수정하기
   * [수거 완료(3), 교환 처리 지연(4)]
   */
  editReasonOrderExchange = async () => {
    const { orderExchangeManagement, getPreparationOrderExchangeEditReason } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  교환 사유 수정하기는 1 건씩만 가능합니다.
     */
    if (orderExchangeManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 사유 수정하기',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 교환 상태가 수거 완료(3), 교환 처리 지연(4)인 경우에만
     *  교환 수거 완료처리를 할 수 있음
     */
    const targetOrderExchangeItem = orderExchangeManagementList.list.find(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST.includes(item.orderItemExchangeStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 교환 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderExchangeItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 사유 수정',
        message: '교환 수거 완료된 상품 주문건에 대해서만 교환 사유 수정이 가능합니다.',
      });
      return;
    }

    /**
     *  교환 사유 수정 하기 전 필요한 데이터들을
     *  백단에서 가져온다
     */
    getPreparationOrderExchangeEditReason({
      orderItemId: targetOrderExchangeItem.orderItemId,
    });
  };

  /**
   * 재배송 송장 수정
   * [재배송중(6)]
   */
  editDeliveryInfo = async () => {
    const { orderExchangeManagement, getDeliveryAgentListForOrderExchange } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  상품 주문 교환 상태가 재배송중(6)인 경우에만
     *  재배송 송장 수정을 할 수 있음
     */
    const targetOrderExchangeItemList = orderExchangeManagementList.list.filter(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        item.orderItemExchangeStatus === ORDER_EXCHANGE_STATUS.DELIVERY_SHIPPING,
    );

    /**
     *  선택한 상품 주문서에 재배송중(6)건이 없을 경우
     */
    if (!targetOrderExchangeItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '재배송 송장 수정',
        message: '재배송중인 상품 주문건에 대해서만 재배송 송장 수정이 가능합니다.',
      });
      return;
    }

    /**
     *  재배송 송장 수정을 위해
     *  택배방법, 택배사, 송장번호를 입력하는 모달을 열도록 함
     */
    getDeliveryAgentListForOrderExchange({
      targetModalName: 'editExchangeDeliveryInfoModal',
      orderItemList: targetOrderExchangeItemList.map((item) => ({
        orderItemId: item.orderItemId,
        productName: item.productName,
        productPrice: item.productPrice,
      })),
    });
  };

  /**
   * 교환 재배송 처리 (교환완료)
   * [수거 완료(3), 교환 처리 지연(4)]
   */
  completeOrderExchange = async () => {
    const { orderExchangeManagement, getDeliveryAgentListForOrderExchange } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  교환 재배송 처리는 1 건씩만 가능합니다.
     */
    if (orderExchangeManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 재배송 처리',
        message: '교환 재배송 처리는 1건씩만 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 교환 상태가 수거 완료(3), 교환 처리 지연(4)인 경우에만
     *  교환 재배송 처리를 할 수 있음
     */
    const targetOrderExchangeItem = orderExchangeManagementList.list.find(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST.includes(item.orderItemExchangeStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 교환 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderExchangeItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 재배송 처리',
        message: '교환 수거 완료된 상품 주문건에 대해서만 교환 재배송 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  교환 완료에 필요한 택배사 리스트를 가져온 후
     *  교환 재배송 처리를 위해 교환 배송 택배 정보를
     *  입력하는 모달을 열도록 함
     */
    getDeliveryAgentListForOrderExchange({
      targetModalName: 'completeExchangeModal',
      orderItemId: targetOrderExchangeItem.orderItemId,
      productName: targetOrderExchangeItem.productName,
      productPrice: targetOrderExchangeItem.productPrice,
      buyerPhone: targetOrderExchangeItem.buyerPhone,
      recipientPhone: targetOrderExchangeItem.recipientPhone,
      address: {
        postCode: targetOrderExchangeItem.shippingPostCode,
        line1: targetOrderExchangeItem.shippingAddress1,
        line2: targetOrderExchangeItem.shippingAddress2,
      },
      shippingMessage: targetOrderExchangeItem.shippingMessage,
    });
  };

  /**
   * 교환 거부 처리
   * [수거 완료(3), 교환 처리 지연(4)]
   */
  rejectOrderExchange = async () => {
    const { orderExchangeManagement, toggleModal } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  교환 거부는 1 건씩만 가능합니다.
     */
    if (orderExchangeManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 거부 처리',
        message: '1건에 대해서만 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 교환 상태가 수거 완료(3), 교환 처리 지연(4)인 경우에만
     *  교환 거부 처리를 할 수 있음
     */
    const targetOrderExchangeItem = orderExchangeManagementList.list.find(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST.includes(item.orderItemExchangeStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 교환 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderExchangeItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '교환 거부 처리',
        message: '교환 수거 완료된 상품 주문건에 대해서만 교환 거부 처리가 가능합니다.',
      });
      return;
    }

    /**
     *  교환 거부 처리를 위해 교환 거부 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    toggleModal({
      name: 'rejectExchangeModal',
      data: {
        orderItemId: targetOrderExchangeItem.orderItemId,
        productName: targetOrderExchangeItem.productName,
        productPrice: targetOrderExchangeItem.productPrice,
        /**
         *  수거 실패 -> 교환 거부, 그냥 교환 거부는 알림톡 내용이 다르다
         *  exchangeStatus 값으로 위의 두가지를 판단이 가능하므로
         *  exchangeStatus 값을 넘긴다.
         */
        orderItemExchangeStatus: targetOrderExchangeItem.orderItemExchangeStatus,
      },
    });
  };

  /**
   * 교환에서 반품으로 변경하기
   * [수거 완료(3), 교환 처리 지연(4)]
   */
  changeExchangeToReturn = async () => {
    const { orderExchangeManagement, changeExchangeToReturn } = this.props;
    const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderExchangeManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  반품으로 변경은 1 건씩만 가능합니다.
     */
    if (orderExchangeManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품으로 변경',
        message: '반품으로 변경은 1건씩만 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 교환 상태가 수거 완료(3), 교환 처리 지연(4)인 경우에만
     *  교환에서 반품으로 변경 할 수 있음
     */
    const targetOrderExchangeItem = orderExchangeManagementList.list.find(
      (item) =>
        orderExchangeManagementSelectedList.includes(item.id) &&
        EXCHANGE_PROGRESS_EXCHANGE_STATUS_LIST.includes(item.orderItemExchangeStatus),
    );

    /**
     *  선택한 상품 주문서에 수거 완료(3), 교환 처리 지연(4)건이 없을 경우
     */
    if (!targetOrderExchangeItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '반품으로 변경',
        message: '교환 수거 완료된 상품 주문건에 대해서만 반품으로 변경이 가능합니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 수거 완료(3), 교환 처리 지연(4) 건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const changeExchangeConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '반품으로 변경',
      message:
        `선택하신 상품 주문번호 ${targetOrderExchangeItem.orderItemId} 를 \n` + `반품으로 변경을 하시겠습니까?\n`,
      okText: '반품으로 변경',
    });

    /**
     *  교환에서 반품으로 변경을 하도록 함
     */
    if (changeExchangeConfirmResult) {
      changeExchangeToReturn({
        orderItemId: targetOrderExchangeItem.orderItemId,
      });
    }
  };

  render() {
    const { orderExchangeManagement, setData, getOrderExchangeAttachment } = this.props;

    return (
      <OrderExchangeManagementListWrap
        orderExchangeManagement={orderExchangeManagement}
        setData={setData}
        getOrderExchangeAttachment={getOrderExchangeAttachment}
        getList={this.getList}
        getAllListExcelDownload={this.getAllListExcelDownload}
        getSelectedListExcelDownload={this.getSelectedListExcelDownload}
        onCheckOrderItem={this.onCheckOrderItem}
        completeCollectionOrderExchange={this.completeCollectionOrderExchange}
        failCollectionRejectOrderExchange={this.failCollectionRejectOrderExchange}
        editReasonOrderExchange={this.editReasonOrderExchange}
        editDeliveryInfo={this.editDeliveryInfo}
        completeOrderExchange={this.completeOrderExchange}
        rejectOrderExchange={this.rejectOrderExchange}
        changeExchangeToReturn={this.changeExchangeToReturn}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderExchangeManagement: state.order.orderExchangeManagement,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  toggleModal: orderActions.toggleModal,
  getOrderExchangeManagementList: orderActions.getOrderExchangeManagementList,
  getOrderExchangeManagementAllListExcelDownload: orderActions.getOrderExchangeManagementAllListExcelDownload,
  getOrderExchangeManagementSelectedListExcelDownload: orderActions.getOrderExchangeManagementSelectedListExcelDownload,
  completeCollectionOrderExchange: orderActions.completeCollectionOrderExchange,
  getPreparationOrderExchangeEditReason: orderActions.getPreparationOrderExchangeEditReason,
  getDeliveryAgentListForOrderExchange: orderActions.getDeliveryAgentListForOrderExchange,
  changeExchangeToReturn: orderActions.changeExchangeToReturn,
  getOrderExchangeAttachment: orderActions.getOrderExchangeAttachment,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderExchangeManagementContainer);
